import React, { forwardRef, useEffect, useRef } from "react";
import styles from "./styles.module.scss";
import InfoIcon from "../../../assets/svg/icons/common/info";
import useDomainStore from "../../../stores/domain";

// ToDo: Remove forwardRef when we upgrade to React 19.
export const TextArea = forwardRef(
  (
    {
      id,
      name,
      label,
      placeholder,
      touched = false,
      errored = false,
      error = "",
      hasWarning = "",
      rows = 3,
      minRows = 3,
      hasInfoIcon = false,
      infoIconTooltip = "",
      ...props
    },
    ref,
  ) => {
    const { isKurvDomain } = useDomainStore();
    const textareaRef = useRef(null);

    const adjustHeight = () => {
      const textarea = ref || textareaRef;
      if (!textarea.current) return;

      textarea.current.style.height = "auto";

      const scrollHeight = textarea.current.scrollHeight;
      const lineHeight = parseInt(
        window.getComputedStyle(textarea.current).lineHeight,
      );
      const minHeight = lineHeight * minRows;

      const newHeight = Math.max(scrollHeight, minHeight);
      textarea.current.style.height = `${newHeight}px`;
    };

    useEffect(() => {
      adjustHeight();
    }, []);

    const handleInput = () => {
      adjustHeight();
    };

    const hasError = touched && errored && error;

    return (
      <div className={`${styles.formGroup} ${isKurvDomain ? styles.kurv_theme : ""}`}>
        <label
          className={styles.label}
          htmlFor={id}
          style={{ display: !label && "none" }}
        >
          {label}
        </label>
        <div className={styles.textareaWrapper}>
          <textarea
            ref={ref || textareaRef}
            className={`${styles.textarea} ${hasError && styles.errorTextarea} ${hasInfoIcon && styles.hasInfoIcon}`}
            id={id}
            placeholder={placeholder || label}
            name={name}
            rows={rows}
            onInput={handleInput}
            {...props}
          />
        </div>
        {hasError && (
          <span className={styles.error} role="alert">
            {error}
          </span>
        )}
        {hasWarning && (
          <span className={styles.warning} role="alert">
            {hasWarning}
          </span>
        )}
        {hasInfoIcon && (
          <span className={styles.infoIcon} data-tip={infoIconTooltip}>
            <InfoIcon />
          </span>
        )}
      </div>
    );
  },
);

TextArea.displayName = "TextArea";

export default TextArea;
